'use client'

interface JoinRejectedNoticeProps {
  reasons: string[]
}

// Shown in place, and left on screen, when a join is refused on country.
//
// A toast alone was not enough for this one. An already-signed-in member never
// sees the field it reads — the AngelHack Account form carrying it is hidden
// from anyone with an account — so the refusal is about data they cannot see on
// this page, and a toast arrives after a round trip and then disappears.
// Anyone who looked away, or never reached a page with a toast at all, is left
// with no explanation.
//
// Two callers: EventActions checks a member's profile the moment they click
// "Join Hackathon", before any navigation; CustomizedMainForm checks again
// after a guest fills in the registration form. Deliberately only the reasons
// — the caller decides when this is worth showing, filtering on the attribute
// the backend names rather than on wording.
export const JoinRejectedNotice = ({ reasons }: JoinRejectedNoticeProps) => {
  if (reasons.length === 0) return null

  return (
    <div
      role="alert"
      className="rounded-lg border border-red-300 bg-red-50 p-4 text-sm"
    >
      <p className="font-semibold text-red-800">
        You can&apos;t join this event
      </p>

      <ul className="mt-2 list-disc space-y-1 pl-5 text-red-700">
        {reasons.map((reason) => (
          <li key={reason}>{reason}</li>
        ))}
      </ul>
    </div>
  )
}
